import React from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { fg } from '@atlassian/jira-feature-gating';
import { Skeleton, SkeletonCompiled } from './styled.tsx';

/**
 * @deprecated styled version is deprecated, please use the compiled version
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FillOld = styled(Skeleton)({
	width: '100%',
	height: '100%',
	display: 'inline-block',
	'&::after': {
		content: "'\\a0'",
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FillCompiled = styled2(SkeletonCompiled)({
	width: '100%',
	height: '100%',
	display: 'inline-block',
	'&::after': {
		content: "'\\a0'",
	},
});

export const Fill = () => (fg('jfp-1298-skeleton-use-compiled') ? <FillCompiled /> : <FillOld />);

export default Fill;
